var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconInstagram = function SvgIconInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-instagram_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.506,
    width: 14,
    height: 14,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 4.506a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.506,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-instagram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .506)",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgIconInstagram as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxyZWN0IHg9IjEiIHk9IjEuNTA1ODYiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgcng9IjMiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTEzLjAwMDEgNC41MDU4NkMxMy4wMDAxIDUuMDU4MDkgMTIuNTUyNCA1LjUwNTg2IDEyIDUuNTA1ODZDMTEuNDQ3OCA1LjUwNTg2IDExIDUuMDU4MDkgMTEgNC41MDU4NkMxMSAzLjk1MzUgMTEuNDQ3OCAzLjUwNTg2IDEyIDMuNTA1ODZDMTIuNTUyNCAzLjUwNTg2IDEzLjAwMDEgMy45NTM1IDEzLjAwMDEgNC41MDU4NloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8Y2lyY2xlIGN4PSI4IiBjeT0iOC41MDU4NiIgcj0iMyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUwNTg1OSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";